import { UUID } from 'crypto';
import { RotationCargo } from 'src/types/ViewModel/Stowage/Rotation/RotationCargo';

// Reds
const reds = ['FF6961', 'FF827B', 'FF9A94', 'FFB3AE', 'FFCBC7', 'FFE4E1'];

// Oranges
const yellows = ['FF8C00', 'FFA124', 'FFB648', 'FFCA6D', 'FFDB91', 'FFF4B5'];

// Greens
const greens = ['20BA20', '44C843', '68D666', '8BE388', 'AFF1AB', 'D3FFCE'];

// Blues
const blues = ['65CEEB', '7ED8EF', '96E2F3', 'AFEBF7', 'C7F5FB', 'E0FFFF'];

// Purples
const purples = ['BA55D3', 'C06BD4', 'C680D5', 'CC96D6', 'D2ABD7', 'D8C1D8'];

export const cargoColors = [...reds, ...yellows, ...greens, ...blues, ...purples];

const getModularColorIndex = (id: number | undefined): number => {
    return id !== undefined ? id % cargoColors.length : 0;
};

export const getColorIndex = (cargoUuid: UUID): number => {
    // TODO: VALIDATION - parseInt on slice(-6) of UUID can return NaN if the last 6 characters are not valid hex. Should validate hex characters or provide fallback handling.
    const hexId = cargoUuid ? parseInt(cargoUuid.toString().slice(-6), 16) : undefined;
    return getModularColorIndex(hexId);
};

export const getNewRandomColorId = (): number => {
    return Math.floor(Math.random() * cargoColors.length);
};

export const getColorById = (cargoUuid: UUID): string | undefined => {
    const colorIndex = getColorIndex(cargoUuid);
    return cargoUuid ? cargoColors[colorIndex] : undefined;
};

export const getCargoColor = (cargo: RotationCargo): string => {
    if (cargo.colorId !== null && cargo.colorId !== undefined && cargo.colorId >= 0 && cargo.colorId < cargoColors.length) {
        return cargoColors[cargo.colorId];
    }
    // TODO: TYPE-SAFETY - Function returns string but getColorById can return undefined, which would cause a type mismatch. Should provide a fallback default color or handle undefined case.
    return getColorById(cargo.cargoGuid);
};
